/**
 * Design Tokens — Arbo Finance App
 * Sistema de diseño centralizado con paleta semántica.
 */

export const P = {
  bg:      "#F3F4F6",
  surface: "#FFFFFF",
  border:  "#E5E7EB",
  borderMd:"#D1D5DB",
  text:    "#111827",
  textMd:  "#44455A",
  textSm:  "#6B7280",
  textXs:  "#6B7280",
  dark:    "#1E293B",

  ingresos: {
    base:   "#143D2E",
    pastel: "#E8F4EE",
    tint:   "#C3E0CF",
    shadow: "rgba(20,61,46,0.12)",
    text:   "#0D2B20",
    mid:    "#1A5C42",
  },
  fijos: {
    base:   "#3B4FA8",
    pastel: "#EEF0FD",
    tint:   "#CDD3F8",
    shadow: "rgba(59,79,168,0.12)",
    text:   "#2A3880",
    mid:    "#4F63CC",
  },
  extras: {
    base:   "#C65D3B",
    pastel: "#FBF0EC",
    tint:   "#F4C9BB",
    shadow: "rgba(198,93,59,0.12)",
    text:   "#8B3320",
    mid:    "#D97050",
  },
  ahorro: {
    base:   "#D97706",
    pastel: "#FEF9EC",
    tint:   "#FDE8B0",
    shadow: "rgba(217,119,6,0.12)",
    text:   "#7A4E06",
    mid:    "#F59E0B",
  },
  danger: {
    base:   "#DC2626",
    pastel: "#FEF2F2",
    tint:   "#FECACA",
    shadow: "rgba(220,38,38,0.12)",
    text:   "#991B1B",
    mid:    "#EF4444",
  },
  warn: {
    base:   "#D97706",
    pastel: "#FFFBEB",
    tint:   "#FDE68A",
    shadow: "rgba(217,119,6,0.12)",
    text:   "#92400E",
    mid:    "#F59E0B",
  },
  brand: {
    primary:  "#143D2E",
    terracota:"#C65D3B",
    leaf:     "#1A5C42",
    bark:     "#5C4033",
    cream:    "#F3F4F6",
  },
  success: {
    base:   "#059669",
    light:  "#34D399",
    pastel: "#ECFDF5",
    tint:   "#D1FAE5",
    text:   "#065F46",
  },
  tdc: {
    base:   "#7C3AED",
    light:  "#9F5AED",
    pastel: "#EDE9FE",
    tint:   "#C4B5FD",
    text:   "#5B21B6",
  },
  transfer: {
    base:   "#6366F1",
    pastel: "#EEF2FF",
    tint:   "#C7D2FE",
    text:   "#3730A3",
  },
};

export const FF = "'Outfit', sans-serif";

export const shadow   = () => "0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)";
export const shadowMd = () => "0 2px 8px rgba(0,0,0,0.07), 0 8px 24px rgba(0,0,0,0.05)";

export const inputBase = {
  border: `1.5px solid ${P.border}`,
  borderRadius: 12,
  background: P.bg,
  color: P.text,
  fontSize: 14,
  fontFamily: FF,
  /* outline managed by global.css :focus-visible */
  padding: "9px 12px",
  fontWeight: 500,
  width: "100%",
  boxSizing: "border-box",
  transition: "border-color .15s",
};
